import { getSession, setSession } from './helpers/Session';
import { clone } from './helpers/CommonUtils';

export function getCoveragePrefs(): string[] {
	const session = getSession();
	const cid = session.customerId;
	const filters = session.metaProductListingOptions.coverageFilters[cid] || [
		'S',
		'D',
		'R',
		'N',
	];

	return filters;
}

export function setCoveragePrefs(value: string[]) {
	const session = getSession();
	const cid = session.customerId;
	const nextSession = clone(session);
	nextSession.metaProductListingOptions.coverageFilters[cid] = value;
	setSession(nextSession);
}
